import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import Button from '../../../components/Button/Button';

import { WarningIcon } from '../../../images/shapes';

export interface SyncWebhookErrorLogsType {
  openSyncWebhookLogModal: () => Promise<void>;
  testId?: string;
}

export const SyncWebhookErrorLogs = ({
  openSyncWebhookLogModal,
  testId,
}: SyncWebhookErrorLogsType) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-center gap-2 px-3 py-2 border border-red-600 rounded-md w-fit dark:border-orange-500"
      {...getTestProps(testId, 'sync-webhook-error-log-notice-container')}
    >
      <WarningIcon className={'w-4 h-4 text-red-600 dark:text-orange-500'} />
      <span className="text-slate-900 font-bold text-sm dark:text-slate-200">
        {t('Webhooks.SyncErrorMessage')}
      </span>
      <Button
        buttonColor="borderless"
        additionalClasses="h-fit! text-sm"
        additionalChildrenClasses="font-bold text-slate-900 dark:text-slate-200"
        onClick={() => openSyncWebhookLogModal()}
        {...getTestProps(testId, 'open-sync-webhook-log-modal-button')}
      >
        {t('Webhooks.SeeDetails')}
      </Button>
    </div>
  );
};

export default SyncWebhookErrorLogs;
